@if (loading) {
  <div class="impact-dashboard-loading">
    <pdq-loader></pdq-loader>
  </div>
} @else if (hasAnnualizedRevenue) {
  <impact-dashboard-after-abtest-winner></impact-dashboard-after-abtest-winner>
} @else {
  <impact-dashboard-before-any-abtest-winner></impact-dashboard-before-any-abtest-winner>
}
